<div class="slider-wrapper">
  <div class="slider-main-container">
    <div *ngIf="showAllDatesInput" class="all-dates-btn" (click)="handleShowAllDates()" [ngClass]="{'active': showAllDates}">
      <span>All Dates</span>
    </div>

    <div class="scrolling-nav" *ngIf="visibleItems">
      <button class="nav-btn prev" (click)="previousItem()" [disabled]="showAllDates || visibleItems[0] === sliderItems[0]">
        <i class="fas fa-chevron-left"></i>
      </button>

      <div class="items-viewport">
        <div class="items-container" [ngClass]="{'centered': visibleItems.length < 5}">
          <div *ngFor="let item of visibleItems; let i = index" 
               class="slider-item" 
               [ngClass]="{'active': (item == sliderItems[selectedItemIndex] && !showAllDates)}"
               (click)="activateSliderOption(item, i)">
            <span class="item-text">{{ item }}</span>
          </div>
        </div>
      </div>

      <button class="nav-btn next" (click)="nextItem()" [disabled]="visibleItems[visibleItems.length - 1] === sliderItems[sliderItems.length-1]">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>